export const API_URL = "https://members-ng.iracing.com/"

export const DEFAULT_OPTIONS = {
  logger: false,
  manageRateLimit: false,
  rateLimitPadding: 5,
}
